import { z } from 'zod';

import {
  formFieldSchema,
  formPresentationSchema,
  MAX_CLIENT_SIDE_FORM_FIELDS,
} from './clientSideTools';
import { baseToolDefinitionSchema } from './mcpIntegration';

const clientSideFormToolBaseSchema = baseToolDefinitionSchema.extend({
  name: z
    .string()
    .min(1)
    .max(60)
    .regex(
      /^[a-z][\d_a-z]*$/,
      'Lowercase letters, digits and underscores; must start with a letter',
    ),
  description: z.string().min(10).max(1000),
  formTitle: z.string().min(1).max(120),
  formDescription: z.string().max(500).optional(),
  submitLabel: z.string().max(40).default('Submit'),
  presentation: formPresentationSchema.default('inline'),
  disableDismiss: z.boolean().default(false),
  fields: z
    .array(formFieldSchema)
    .min(1)
    .max(MAX_CLIENT_SIDE_FORM_FIELDS)
    .superRefine((fields, ctx) => {
      const names = new Set<string>();

      for (const [index, field] of fields.entries()) {
        if (names.has(field.name)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: [index, 'name'],
            message: 'Field names must be unique',
          });
        }

        names.add(field.name);
      }
    }),
});

export const createClientSideFormToolSchema = clientSideFormToolBaseSchema;

export const updateClientSideFormToolSchema = clientSideFormToolBaseSchema
  .partial()
  .extend({ id: z.string().uuid() });

export const clientSideFormToolOutputSchema =
  clientSideFormToolBaseSchema.extend({
    id: z.string().uuid(),
  });

export type CreateClientSideFormToolDTO = z.infer<
  typeof createClientSideFormToolSchema
>;
export type UpdateClientSideFormToolDTO = z.infer<
  typeof updateClientSideFormToolSchema
>;
export type ClientSideFormToolOutput = z.infer<
  typeof clientSideFormToolOutputSchema
>;
